import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { getPointsTask, postPointsTask } from '../../../api/points';
import { Task } from '../../../type/points';
import lodash from 'lodash';
import ModalItem from '@/component/ModalItem/ModalItem.vue';
//可编辑的任务数组

export default /*#__PURE__*/_defineComponent({
  __name: 'task',
  setup(__props) {

const disabledId = ref<any[]>([]);
function onEdit(id) {
  disabledId.value = [...disabledId.value, id];
}
async function onSave(id) {
  disabledId.value = [...disabledId.value.filter(item => item != id)];
  const thisTask = basics.value.find(item => item.id == id);
  const data = {
    daily_times: thisTask?.daily_times || 0,
    extend: id == 11 ? { time: Number(thisTask?.extend?.time) } : {}, 
    points: thisTask?.points || 0,
    status: thisTask?.status || 0,
  };
  if (await postPointsTask(id, data)) {
    initValue.value = lodash.cloneDeep(basics.value);
  } else {
    // eslint-disable-next-line require-atomic-updates
    basics.value = lodash.cloneDeep(initValue.value);
  }
}
function onCancel(id) {
  disabledId.value = [...disabledId.value.filter(item => item != id)];
  basics.value = lodash.cloneDeep(initValue.value);
}
const basics = ref<Task[]>([]);
const initValue = ref<Task[]>([]);
async function query() {
  const res = await getPointsTask();
  const data = res.map(item => ({
    ...item,
    extend: JSON.parse(item.extend),
  }));
  basics.value = lodash.cloneDeep(data);
  initValue.value = lodash.cloneDeep(data);
}
query();
function editStatus(id, val) {
  basics.value = [
    ...basics.value.map(item =>
      item.id == id
        ? {
            ...item,
            status: val,
          }
        : item
    ),
  ];
}

return { __sfc: true,disabledId, onEdit, onSave, onCancel, basics, initValue, query, editStatus, ModalItem }
}

})